import { REPORT_NAVIGATION_TOGGLE_EXPANDED, REPORT_NAVIGATION_SET_POSITION } from './constants'

export function reportNavigationToggleExpanded() {
    return {
        type: REPORT_NAVIGATION_TOGGLE_EXPANDED,
    }
}

export function reportNavigationSetPosition(position, maxPosition) {
    return {
        type: REPORT_NAVIGATION_SET_POSITION,
        data: {
            position,
            maxPosition,
        },
    }
}
